var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMsgBubbles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 146,
    viewBox: "0 0 151 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128.834 27.1035H124.4V66.6334C124.4 83.5846 110.477 97.3789 93.3677 97.3789H60.8999L43.8803 110.37C47.6555 113.232 52.3266 114.948 57.3106 114.948H92.7962L133.267 145.839V114.506C143.371 112.465 151 103.594 151 92.9867V49.0646C151 36.9563 141.055 27.1035 128.834 27.1035Z",
    fill: "#4A3A80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3536 88.7991H93.9305C106.183 88.7991 116.154 78.8393 116.154 66.5993V22.1998C116.154 9.95984 106.183 0 93.9305 0H22.2233C9.9704 0 0 9.95984 0 22.1998V66.5993C0 77.3223 7.64852 86.2889 17.7787 88.3528V120.026L58.3536 88.7991ZM26.668 22.1998H89.4859V31.0797H26.668V22.1998ZM26.668 39.9596H89.4859V48.8395H26.668V39.9596ZM26.668 57.7194H71.7072V66.5993H26.668V57.7194Z",
    fill: "#F1805E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsgBubbles);
export default __webpack_public_path__ + "static/media/msg_bubbles.b4698ff646b13ab9d0b3db10e2eaefde.svg";
export { ForwardRef as ReactComponent };